import { UploadModelData } from "@iventis/types/model-types";

/** Return changed model data from UploadModelData */
export const getChangedModelData = (updated: UploadModelData, original: UploadModelData): Partial<UploadModelData> => {
    const changedData: Partial<UploadModelData> = {};
    if (updated.name !== original.name) {
        changedData.name = updated.name;
    }
    if (
        updated.categories.length !== original.categories.length ||
        updated.categories.some((updatedCategory) => !original.categories.some((original) => original === updatedCategory))
    ) {
        changedData.categories = updated.categories;
    }
    if (updated.size?.height !== original.size?.height || updated.size?.length !== original.size?.length || updated.size?.width !== original.size?.width) {
        changedData.size = updated.size;
    }
    if (updated.model.modelUrl !== original.model.modelUrl) {
        changedData.model = updated.model;
    }
    if (updated.thumbnail.changed) {
        changedData.thumbnail = updated.thumbnail;
    }
    if (updated.aspectRatio?.height !== original.aspectRatio?.height || updated.aspectRatio?.width !== original.aspectRatio?.width) {
        changedData.aspectRatio = updated.aspectRatio;
    }

    // Metadata is not patched in the backend, it is replaced due to it being stored as a json string. So we always want it set
    changedData.customColour = updated.customColour;
    changedData.customImage = updated.customImage;
    changedData.variableSizeModel = updated.variableSizeModel;

    return { ...changedData, modelId: original.modelId, thumbnailId: original.thumbnailId };
};
